export class ChatbotModel {
  public Direction: string;
  public Message: string;

  constructor(direction: string, message: string) {
    this.Direction = direction;
    this.Message = message;
  }
}
